import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { WorkStackParamList } from '../types/navigation';
import WorkHomeScreen from '../screens/work/WorkHomeScreen';
import ContractDetailScreen from '../screens/work/ContractDetailScreen';
import ProductDetailScreen from '../screens/work/ProductDetailScreen';
import SupplyDetailScreen from '../screens/work/SupplyDetailScreen';
import AddContractScreen from '../screens/work/AddContractScreen';
import AddProductScreen from '../screens/work/AddProductScreen';
import AddSupplyScreen from '../screens/work/AddSupplyScreen';
import AddJobScreen from '../screens/work/AddJobScreen';
import EditJobScreen from '../screens/work/EditJobScreen';
import EditProductScreen from '../screens/work/EditProductScreen';
import SendQuoteScreen from '../screens/work/SendQuoteScreen';
import EditQuoteScreen from '../screens/work/EditQuoteScreen';

const Stack = createStackNavigator<WorkStackParamList>();

const WorkNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="WorkHome" component={WorkHomeScreen} />
      <Stack.Screen 
        name="ContractDetail" 
        component={ContractDetailScreen}
        options={{
          presentation: 'card',
        }}
      />
      <Stack.Screen 
        name="ProductDetail" 
        component={ProductDetailScreen}
        options={{
          presentation: 'card',
        }}
      />
      <Stack.Screen 
        name="SupplyDetail" 
        component={SupplyDetailScreen}
        options={{
          presentation: 'card',
        }}
      />
      <Stack.Screen 
        name="AddContract" 
        component={AddContractScreen}
        options={{
          presentation: 'modal',
        }}
      />
      <Stack.Screen 
        name="AddProduct" 
        component={AddProductScreen}
        options={{
          presentation: 'modal',
        }}
      />
      <Stack.Screen 
        name="AddSupply" 
        component={AddSupplyScreen}
        options={{
          presentation: 'modal',
        }}
      />
      <Stack.Screen 
        name="AddJob" 
        component={AddJobScreen}
        options={{
          presentation: 'modal',
        }}
      />
      <Stack.Screen 
        name="EditJob" 
        component={EditJobScreen}
        options={{
          presentation: 'modal',
        }}
      />
      <Stack.Screen 
        name="EditProduct" 
        component={EditProductScreen}
        options={{
          presentation: 'modal',
        }}
      />
      <Stack.Screen 
        name="SendQuote" 
        component={SendQuoteScreen}
        options={{
          presentation: 'modal',
        }}
      />
      <Stack.Screen 
        name="EditQuote" 
        component={EditQuoteScreen}
        options={{
          presentation: 'modal',
        }}
      />
    </Stack.Navigator>
  );
};

export default WorkNavigator;
